var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AntTabs',_vm._g(_vm._b({attrs:{"default-active-key":_vm.defaultActiveTab}},'AntTabs',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.tabs),function(tab,index){return _c('TabPane',{key:index,attrs:{"tab":_vm.$t(tab)}},[_vm._t(tab)],2)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }